import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

// Cabeçalho de página padrão: título (h1), subtítulo opcional e área de ações.
// Usado por TODAS as telas para garantir hierarquia e espaçamento consistentes.
export function PageHeader({
  title,
  subtitle,
  actions,
  className,
  titleClassName,
}: {
  title: string
  subtitle?: ReactNode
  actions?: ReactNode
  className?: string
  titleClassName?: string
}) {
  return (
    <div className={cn('flex flex-wrap items-start justify-between gap-3', className)}>
      <div className="min-w-0">
        <h1 className={cn('text-2xl font-semibold tracking-tight', titleClassName)}>{title}</h1>
        {subtitle && <p className="text-muted-foreground text-sm">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  )
}
